<template>
    <tr class="storage_device">
      <td data-label="№" class="w5per">
        {{ storage_key + 1 }}
      </td>
      <td :data-label="translate('storage.date')" class="w7per" v-html="get_date_any_lines(storage_device.ts_update, null, 2)"></td>
      <td :data-label="translate('storage.client_order_name')" class="w30per">
        <router-link :to="{path: '/client_order/' + storage_device.client_order_id}">
          {{ storage_device.client_order_name }}
        </router-link>
      </td>
      <td :data-label="translate('storage.device_name')" class="device w10per">
        <router-link :to="{path: '/device/' + storage_device.device_fid}">
          {{ storage_device.device_fid }}
        </router-link>
        <p>{{ storage_device.device_name }}</p>
      </td>
      <td :data-label="translate('storage.device_sku')" class="w10per">
        {{ storage_device.device_sku }}
      </td>
      <td :data-label="translate('storage.device_model_name')" class="w10per">
        {{ storage_device.device_model_name }}
      </td>
      <td :data-label="translate('storage.status')" class="w7per">
        <span class="badge" :style="'background-color: ' + get_status(storage_device.status).color">
          {{ get_status(storage_device.status).title }}
        </span>
      </td>
      <td :data-label="translate('storage.defect')" class="w10per">
        <span class="badge" :style="'background-color: ' + get_defect(storage_device.defect).color">
          {{ get_defect(storage_device.defect).title }}
        </span>
      </td>
    </tr>
</template>
<script>


export default {
  name: 'StorageDevicesListItem',
  props: ["storage_device", "storage_key"],
  data () {
    return {
      ts_date_options:{
        hour12: false,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }
    }
  },
  methods: {
    get_status(status_id){
      let status = this.$store.getters.getStorageListInfo.statuses.find((status) => {
        if (status.id === status_id) return status
      })
      return status ? {...status, title: this.translate("storage.statuses." + status.title) } : {title: "Error", color: "red"}
    },
    get_defect(defect_id){
      let defect = this.$store.getters.getStorageListInfo.defects.find((defect) => {
        if (defect.id === defect_id) return defect
      })
      return defect ? {...defect, title: this.translate("storage.defects." + defect.title) } : {title: "Error", color: "red"}
    },
  }
}
</script>

<style lang="scss" scoped>
.storage_device{
  td{
    font-size: 12px;
    &.device{
      text-align: left;
      p,a{
        margin-bottom: 0;
        font-size: 12px;
      }
    }
  }
}
</style>
